class ConditionalNavigation {
  constructor() {
    this.navigationCallback = null;
    this.openNavigationWarning = null;
    this.shouldUseConditionalNavigation = false;
  }

  resetConditionalNavigation = () => {
    this.setShouldUseConditionalNavigation(false);
    this.setOpenNavigationWarning(null);
    this.navigationCallback = null;
  };

  resumeNavigation = () => {
    this.navigationCallback && this.navigationCallback();
  };

  showConditionalNavigationWarning = (navigationCallback) => {
    this.navigationCallback = navigationCallback;
    this.openNavigationWarning && this.openNavigationWarning();
    this.setShouldUseConditionalNavigation(false);
  };

  setOpenNavigationWarning = (openWarningDialog) => {
    this.openNavigationWarning = openWarningDialog;
  };

  setShouldUseConditionalNavigation = (shouldUseConditionalNavigation) => {
    this.shouldUseConditionalNavigation = shouldUseConditionalNavigation;
  };
}

const NewConditionalNavigation = new ConditionalNavigation();

export default NewConditionalNavigation;
